const Download = require("path/downloads/models/download").default

class StepAdminStore extends require("lib/static-shim").default(
  require("lib/core/store/backbone-store").default
) {
  static initClass() {
    this.prototype.defaults = {
      download: null // the download being added/deleted
    }

    this.prototype.storeTriggers = {
      "download:added"() {
        return this.get("download")
      },
      "download:deleted"() {
        return this.get("download")
      }
    }

    this.prototype.actions = {
      saveDownload(downloadData) {
        const options = this.request.getDownloadsContext()
        const download = new Download(downloadData, options)
        this._mutate({ download })
        return download.save().then(() => {
          this.storeTrigger("download:added")
          return this._mutate({ download: null })
        })
      },

      deleteDownload(downloadData) {
        const options = this.request.getDownloadsContext()
        const download = new Download(downloadData, options)
        this._mutate({ download })
        return download.destroy().then(() => {
          this.storeTrigger("download:deleted")
          return this._mutate({ download: null })
        })
      }
    }

    this.prototype.requests = {
      getDownloadsContext() {
        const pathStore = this.getStore("path")
        const stepStore = this.getStore("step")
        const options = {
          path: pathStore.get("path").id,
          step: stepStore.get("step").sourceID()
        }
        return options
      }
    }
  }
}
StepAdminStore.initClass()

export default window.App.stores.registerStore(
  "stepDownloadsAdmin",
  StepAdminStore
)
